// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer__JTBOR","signInLinkContainer":"SignUpComponent_signInLinkContainer__36jYJ"};